import {z} from 'zod';

import {normalizeUntouchedDiscount} from './normalizeUntouchedDiscount';
import {PROPOSED_DISCOUNT_VALUE_PATTERN} from './proposedDiscount';

const uuid = z.string().uuid();
const proposedDiscountSchema = z.object({
  kind: z.enum(['percent', 'amount']),
  value: z.string().regex(PROPOSED_DISCOUNT_VALUE_PATTERN),
  basis: z.enum(['net', 'gross']),
});

const optionalProposedDiscountSchema = z
  .custom<
    z.infer<typeof proposedDiscountSchema> | undefined
  >((value) => value === undefined || value === null || normalizeUntouchedDiscount(value) === null || proposedDiscountSchema.safeParse(value).success)
  .transform((value) => normalizeUntouchedDiscount(value) ?? undefined);

export const configuratorFormSchema = z.object({
  makeId: z.string(),
  modelId: z.string(),
  modelYearId: uuid,
  trimId: uuid,
  variantId: uuid,
  colourId: uuid.or(z.literal('')),
  upholsteryId: uuid.or(z.literal('')),
  featureIds: z.array(uuid),
  packageIds: z.array(uuid),
  label: z.string().trim().min(1),
  proposedDiscount: optionalProposedDiscountSchema,
});
